module.exports = __webpack_public_path__ + "acf6c57c3afb6a1ffc1e4a1c49471a52.png";